if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    let form_id_2584 = document.querySelector( "#form_id-2584" );
	if(form_id_2584){

		let htmlGDPR = '<input type="checkbox" name="recurring_automated_promotional_and_personalized_marketing_text" id="form_id-2584-yes-signup-formemail-signup" value="y" aria-required="true"> <label for="form_id-2584-yes-signup-formemail-signup">By checking this box, you agree to receive recurring automated promotional and personalized marketing text messages (e.g. cart reminders) from Everbowl Craft Superfood at the cell number used when signing up. Consent is not a condition of any purchase. Reply HELP for help and STOP to cancel. Msg frequency varies. Msg & data rates may apply. View <a href="/privacy-policy">Terms & Privacy</a>.</label>';
		
		let div = document.createElement('div')
		div.classList.add("field") 
		div.classList.add("gdpr")
		div.classList.add("clearfix")
		div.innerHTML = htmlGDPR

		form_id_2584.querySelector( ".gdpr-wrap" ).appendChild( div )

	}
	if(form_id_2584){
		
		let policyRemoveRequired = document.querySelector('[name="i_agree"]');
		let policyRemoveRequiredOffer =document.querySelector('[name="subscribe"]');
		console.log(policyRemoveRequiredOffer);
		
		let parent = policyRemoveRequired.parentElement;
		 let parentOffer = policyRemoveRequiredOffer.parentElement;

		parent.classList.add('hidden');
		parentOffer.classList.add('hidden');
		policyRemoveRequired.classList.remove('required');

	}


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: false
    });

	if(windowWidth  < 1000){ //tablet
		$('.infographic-slides').slick({
			accessibility: false,
			arrows:false,
			dots:true,
			fade:true,
			adaptiveHeight:true
		});
	}



	//email signup animation 
	if(document.getElementById('email-signup_email_address')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}
	//CMS forms label animation
	if(document.getElementsByClassName('form-module__field').length > 0){
		let allffields = document.getElementsByClassName('form-module__field');
		
	   for(let j = 0; j < allffields.length; j++){
		   
		   if(allffields[j].getElementsByTagName('input').length > 0){
			   if(allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && allffields[j].getElementsByTagName('input')[0].type.toLowerCase() != 'radio'){
				   allffields[j].getElementsByTagName('input')[0].addEventListener('focus', function(){
					   this.parentElement.classList.add('moved');
				   })
			   }
		   }
		   if(allffields[j].getElementsByTagName('select').length > 0){
			   allffields[j].getElementsByTagName('select')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
		   if(allffields[j].getElementsByTagName('textarea').length > 0){
			   allffields[j].getElementsByTagName('textarea')[0].addEventListener('focus', function(){
				   this.parentElement.classList.add('moved');
			   })
		   }
	   }
	}

	//vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open')
				
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open')
			});
		}
	}

})();



